import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import * as _ from "lodash";
import { ToastService } from "ng-uikit-pro-standard";
import { BodegaService } from "src/app/services/bodega.service";
import { FamiliaService } from "src/app/services/familia.service";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { SaldoStockService } from "src/app/services/saldo-stock.service";
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import { ConsoleService } from "src/app/shared/services/console.service";
import { DatesService } from "src/app/shared/services/dates.service";
import { FileDownloadService } from "src/app/shared/services/file-download.service";
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { RutService } from "src/app/shared/services/rut.service";
import { SecurityService } from "src/app/shared/services/security.service";
import { FormatoService } from 'src/app/services/formato.service';

@Component({
  selector: "app-exist-calc-pedido",
  templateUrl: "./exist-calc-pedido.component.html",
  styleUrls: ["./exist-calc-pedido.component.scss"],
  providers: [SecurityService]
})
export class ExistCalcPedidoComponent implements OnInit {
  readonly RB_TIPO_VISTA: String = "_RB_TIPO_VISTA_"
  readonly RB_TIPO_NO_VISTA: String = "_RB_TIPO_NO_VISTA_"
  // Form
  formHeader: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  listaMovimientos: any = null
  listaMovimientosAll: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  currentPayload: any
  totalesDocumento: any = null;

  // Utils
  private log: any

  optionsBodega: Array<any> = [];
  optionsFamilia: Array<any> = [];
  optionsFormComb1: Array<any> = [];
  optionsFormComb2: Array<any> = [];

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private bodegaService: BodegaService,
    private familiaService: FamiliaService,
    private datesService: DatesService,
    private saldoStockService: SaldoStockService,
    private fileDownloadService: FileDownloadService,
    private formatoService: FormatoService,

  ) {
    this.log = this.clog.log('CALCULO-PEDIDO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    this.loadBodegas()
    this.loadFamilias()
    this.loadFormatosComb1()
    this.loadFormatosComb2()
    this.createForms()
    this.formChangesSubscriptions()
  }

  private loadBodegas() {
    this.bodegaService.GetBodegas(this.rutEmpresa, this.sucursalEmpresa, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega => ({ value: bodega.codigo, label: bodega.nombre, sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('listaBodega'), this.optionsBodega)
    })
  }

  private loadFamilias() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        activo: true
      }
    }
    this.log('inputParams', JSON.stringify(inputParams))
    this.familiaService.obtenerTodasFamilias(inputParams, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      let options = registros.map(p => ({ value: p.codigo, label: p.nombre }))
      this.optionsFamilia = this.optionsFamilia.concat(options)
    })
  }

  private loadFormatosComb1() {
    this.formatoService.GetFormatosByComb1(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsFormComb1 = registros.map(formato => ({ value: formato.codigo, label: formato.nombre }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('listaFormComb1'), this.optionsFormComb1)
    })
  }
  private loadFormatosComb2() {
    this.formatoService.GetFormatosByComb2(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsFormComb2 = registros.map(formato => ({ value: formato.codigo, label: formato.nombre }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('listaFormComb2'), this.optionsFormComb2)
    })
  }

  private createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA, [Validators.required]],
      fecha_desde: [initDate, [Validators.required]],
      fecha_hasta: [currentDate, [Validators.required]],
      producto_venta_cero: [false, [Validators.required]],
      dia_venta_efectivo: [null, [Validators.required]],
      dia_stock: [null, [Validators.required]],
      listaBodega: [[], []],
      listaFamilia: [[], []],
      producto_pedido_sugerido: [false, [Validators.required]],
      producto_activo: [true, [Validators.required]],
      listaFormComb1: [''],
      listaFormComb2: ['']
    });
  }

  formChangesSubscriptions() {

  }

  buscar(pageNumber: number = 1) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.paginationContext.CurrentPage = pageNumber

    this.listaMovimientos = []
    this.listaMovimientosAll = []
    this.loading = true

    const { fecha_desde, fecha_hasta, producto_venta_cero, dia_venta_efectivo, dia_stock,
      listaBodega, listaFamilia, producto_pedido_sugerido, producto_activo, listaFormComb1, listaFormComb2 } = this.formHeader.value
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        fecha_desde,
        fecha_hasta,
        producto_venta_cero,
        dia_venta_efectivo,
        dia_stock,
        listaBodega,
        listaFamilia,
        producto_pedido_sugerido,
        producto_activo,
        formato_comb_1: listaFormComb1
      },
      paginaActual: 1, //this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.paginationContext.RecordsByPage
    }
    this.currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.saldoStockService.reporteCalculoPedido(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const { registros } = respuesta

      this.listaMovimientosAll = registros

      this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      // this.paginationContext.CurrentPage = 1

      this.listaMovimientosAll.forEach((detalle, index) => {
        delete detalle.__typename
        detalle.additionalInfo = {
          index,
          cantidad_valid: true
        }
      })

      this.loading = false
      this.showPage(this.paginationContext.CurrentPage)
      //this.log('data', JSON.stringify(this.listaMovimientosAll))
      this.ObtenerTotales(this.listaMovimientosAll)
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  onCantidadChange(doc, value: string): void {
    const selected: any = this.listaMovimientosAll.filter((detalle: any) => detalle.additionalInfo.index === doc.additionalInfo.index)[0]
    selected.additionalInfo.cantidad_valid = value && value.trim().length > 0 && Number(value) >= 0
    selected.stock_difinitivo = Number(value)
    this.ObtenerTotales(this.listaMovimientosAll)
  }

  downloadExcel(type: 'XLS' | 'PDF' = 'XLS') {
    const inputParams = _.cloneDeep(this.currentPayload)
    // delete inputParams.cantidadRegistrosPorPagina
    // delete inputParams.paginaActual
    inputParams.paginaActual = 1
    inputParams.cantidadRegistrosPorPagina = -1

    const listaSaldoStock = _.cloneDeep(this.listaMovimientosAll)
    listaSaldoStock.forEach(detalle => {
      delete detalle.additionalInfo
    })
    inputParams.entidad.listaSaldoStock = listaSaldoStock

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.saldoStockService.reporteCalculoPedidoExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

  downloadPdf(type: 'XLS' | 'PDF' = 'XLS') {
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual
    delete inputParams.entidad.producto_venta_cero
    delete inputParams.entidad.listaBodega
    delete inputParams.entidad.listaFamilia
    delete inputParams.entidad.producto_pedido_sugerido
    delete inputParams.entidad.producto_activo
    delete inputParams.entidad.formato_comb_1
    //inputParams.paginaActual = 1
    //inputParams.cantidadRegistrosPorPagina = -1

    const listaSaldoStock = _.cloneDeep(this.listaMovimientosAll)
    listaSaldoStock.forEach(detalle => {
      delete detalle.additionalInfo
    })
    inputParams.entidad.listaSaldoStock = listaSaldoStock

    //inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.saldoStockService.reportePDFDetallePago(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.rutaArchivo)
    })
  }

  ObtenerTotales(data) {
    this.FetchObtenerTotales(data, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.totalesDocumento = respuesta
    })
  }

  //Obtener totales de documento
  FetchObtenerTotales(data, callback: Function) {
    //this.log('FetchObtenerTotales this.dataCabecera', this.dataCabecera)
    const inputParams = {
      lista: this.cleanDetalledocumento(data),
    }
    //this.log('inputParams', JSON.stringify(inputParams))
    this.saldoStockService.ObtenerTotalesReporte(inputParams, callback)
  }

  private cleanDetalledocumento(detalleDocumento) {
    // let _detalledocumento = [...detalleDocumento]
    // let _detalledocumento = [];
    // detalleDocumento.forEach(val => _detalledocumento.push(Object.assign({}, val)));
    let _detalledocumento = _.cloneDeep(detalleDocumento)
    _detalledocumento.forEach(p => {
      delete p.additionalInfo
      delete p.__typename
      // if (p.atributos)
      //   p.atributos.forEach(attr => {
      //     delete attr.__typename
      //   })
    })
    return _detalledocumento
  }
}
